import { Box } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import { Image } from 'antd';
import React, { useState } from 'react';
import { useTranslate } from 'react-admin';

const ProofsPreview = ({ urls, ...props }) => {
  const [preview, setPreview] = useState(false);
  const t = useTranslate();

  return (urls || []).length > 0 ? (
    <Box
      display="flex"
      sx={{
        gap: 5,
      }}
      alignItems="center"
      justifyContent="center"
      onClick={(e) => {
        e.stopPropagation();
        setPreview(true);
      }}
      {...props}
    >
      <Box whiteSpace="nowrap">
        {t('resources.payment.files', {
          smart_count: urls?.length,
        })}
      </Box>
      <Box
        component={Visibility}
        sx={{
          width: '16px !important',
          height: '16px !important',
        }}
      />
      <Image.PreviewGroup
        preview={{
          visible: preview,
          onVisibleChange: setPreview,
          imageRender: (node) => node,
        }}
        items={urls?.map((proof) => proof)}
      />
    </Box>
  ) : (
    '-'
  );
};

export default ProofsPreview;
